import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
  rank?: number;
}

export default function MangaCard({ manga, rank }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-100 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-0 top-0 flex items-center gap-1 p-2">
          <span
            className={`rounded-md px-2 py-0.5 text-xs font-medium text-background-50 ${
              manga.status === '已完结' ? 'bg-accent-600' : 'bg-primary-600'
            }`}
          >
            {manga.status}
          </span>
        </div>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-background-950/70 text-sm font-bold text-accent-300">
            {rank}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-background-950/80 to-transparent px-3 pb-2 pt-8">
          <span className="text-xs text-background-100">共{manga.chapters}话</span>
          <span className="flex items-center gap-1 text-xs font-semibold text-accent-300">
            <i className="ri-star-fill text-[12px]"></i>
            {manga.score.toFixed(1)}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
          {manga.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600">{manga.author}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {manga.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
            >
              {g}
            </span>
          ))}
          {manga.status === '连载中' && (
            <span className="line-clamp-1 text-[11px] text-primary-600">更新至{manga.latestChapter.replace('第', '第').split(' ')[0]}</span>
          )}
        </div>
      </div>
    </Link>
  );
}